export const getIsSurveyExpired = (surveyExpirationDate: Date | null): boolean =>
  surveyExpirationDate ? new Date() > surveyExpirationDate : false;
